/**
 * Ends at 23:59:59 wiring for MaintenanceTaskModal (REBUILD-592).
 * Shared with unit tests so select/create payload behavior cannot drift from the modal.
 */

import { endsAtMidnightEligible } from '@/shared/lib/endsAtMidnightEligible'

/** Task / new-interval payload flag: hidden window always sends false (legacy parity). */
export const resolveEndsAtMidnightForPayload = (params: {
  showEndsAtMidnight: boolean
  endsAtMidnight: boolean
}): boolean => (params.showEndsAtMidnight ? params.endsAtMidnight : false)

/**
 * When the user picks an existing Calendar frequency and this task's Starts At + that
 * interval's overdue crosses midnight, copy the stored frequency flag into the form.
 * Null API values default to true (legacy checked default). Ineligible windows leave the
 * form flag untouched — the box is hidden and the payload still sends false.
 */
export const resolveEndsAtMidnightOnIntervalSelect = (params: {
  frequencyTypeCode: string
  fixedScheduleStartTime: string
  intervalEndsAtMidnight: boolean | null | undefined
  lateTimeIntervalHours: number | null | undefined
}): { shouldApply: boolean; endsAtMidnight: boolean } => {
  if (params.frequencyTypeCode !== 'CALENDAR_FIXED') {
    return { shouldApply: false, endsAtMidnight: true }
  }

  const startsAt = params.fixedScheduleStartTime
  const overdueMinutes = params.lateTimeIntervalHours
  if (!startsAt || overdueMinutes == null) {
    return { shouldApply: false, endsAtMidnight: true }
  }

  const eligible = endsAtMidnightEligible({ startsAt, overdueMinutes })
  if (!eligible) {
    return { shouldApply: false, endsAtMidnight: true }
  }

  return {
    shouldApply: true,
    endsAtMidnight: params.intervalEndsAtMidnight ?? true,
  }
}
